import React, { lazy, Suspense } from 'react'
import { BrowserRouter, useLocation } from 'react-router-dom'
import AliveAcademicsRoutes from '../../../alive-academics/components/routes/AllRoutes'
import LayoutContextProvider from '../../contexts/layout.context'

const PlacementTrainingRoutes = lazy( () => import( '../../../alive-placements/components/routes/Routes' ) )

const placementPathPrefixes = [
    '/placements',
    '/companies',
    '/company/',
    '/practice',
    '/collection',
    '/collections',
    '/questions',
    '/question/',
    '/attempt/',
    '/assessments',
    '/courses',
    '/admin/dashboard',
    '/admin/leaderboard',
    '/admin/companies',
    '/admin/company/',
    '/admin/collections',
    '/admin/collection/',
    '/admin/questions',
    '/admin/question/',
    '/admin/courses',
    '/admin/programs',
    '/admin/assessments',
    '/admin/student-requests',
    '/admin/placement-tracker',
    '/dev/auditor/placement-tracker',
    '/auditor/dashboard',
    '/auditor/leaderboard',
    '/auditor/courses',
    '/auditor/programs',
    '/auditor/assessments',
    '/auditor/placement-tracker',
    '/placement-monitoring',
    '/admin/placements/analytics',
    '/audit/placements-tracker',
    '/auditor/placements/analytics'
]

const isPlacementPath = ( pathname ) =>
    placementPathPrefixes.some( prefix => pathname === prefix || pathname.startsWith( prefix ) )

const RouteTree = () => {
    const { pathname } = useLocation()

    if ( isPlacementPath( pathname ) )
        return <Suspense fallback={null}><PlacementTrainingRoutes /></Suspense>

    return <AliveAcademicsRoutes />
}

const CombinedRoutes = () => (
    <BrowserRouter future={{ v7_startTransition: true }}>
        <LayoutContextProvider>
            <RouteTree />
        </LayoutContextProvider>
    </BrowserRouter>
)

export default CombinedRoutes
